import { Box, Typography } from "@mui/material";
import { styled, keyframes } from "@mui/system";
// import investOnYourTerm from "../../style/images/invest-on-your-term.svg";
// import wolfpackLogo from "../../style/images/wolfpack-logo.svg"; // 👈 add your wolfpack logo here

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(24px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const StoreButton = styled("a")(() => ({
    display: "inline-flex",
    textDecoration: "none",
    cursor: "pointer",
    borderRadius: "12px",
    overflow: "hidden",
    transition: "transform 0.22s ease, box-shadow 0.22s ease",
    "&:hover": {
        transform: "translateY(-3px)",
        boxShadow: "0 12px 32px rgba(0,0,0,0.4)",
    },
}));

// Phone mockup SVG
const PhoneMockup = () => (
    <svg width="180" height="320" viewBox="0 0 180 320" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="178" height="318" rx="28" fill="#16181E" stroke="rgba(255,255,255,0.15)" strokeWidth="2" />
        <rect x="60" y="10" width="60" height="14" rx="7" fill="#0D0F14" />
        <rect x="16" y="40" width="148" height="84" rx="10" fill="#23242A" />
        <rect x="28" y="55" width="60" height="8" rx="4" fill="#4A7AF2" opacity="0.8" />
        <rect x="28" y="70" width="100" height="6" rx="3" fill="rgba(255,255,255,0.2)" />
        <rect x="28" y="82" width="80" height="6" rx="3" fill="rgba(255,255,255,0.15)" />
        <rect x="28" y="100" width="40" height="14" rx="7" fill="#F2674A" />
        <rect x="16" y="136" width="68" height="72" rx="10" fill="#23242A" />
        <rect x="96" y="136" width="68" height="72" rx="10" fill="#23242A" />
        <circle cx="36" cy="155" r="10" fill="#2E3340" />
        <circle cx="116" cy="155" r="10" fill="#2E3340" />
        <rect x="28" y="170" width="44" height="5" rx="2.5" fill="rgba(255,255,255,0.2)" />
        <rect x="108" y="170" width="44" height="5" rx="2.5" fill="rgba(255,255,255,0.2)" />
        <rect x="28" y="180" width="30" height="5" rx="2.5" fill="rgba(74,222,109,0.6)" />
        <rect x="108" y="180" width="30" height="5" rx="2.5" fill="rgba(242,103,74,0.6)" />
        <rect x="16" y="270" width="148" height="36" rx="10" fill="#23242A" />
        <circle cx="46" cy="288" r="6" fill="#4A7AF2" />
        <circle cx="90" cy="288" r="6" fill="rgba(255,255,255,0.2)" />
        <circle cx="134" cy="288" r="6" fill="rgba(255,255,255,0.2)" />
        <rect x="70" y="308" width="40" height="4" rx="2" fill="rgba(255,255,255,0.3)" />
    </svg>
);

const DownloadApp = () => {
    return (
        <Box
            sx={{
                minHeight: "100vh",
                width: "100%",
                background:
                    "radial-gradient(ellipse at 70% 30%, rgba(74,122,242,0.18) 0%, transparent 60%), radial-gradient(ellipse at 20% 80%, rgba(242,103,74,0.12) 0%, transparent 55%), #0D0F14",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: { xs: "40px 20px", md: "60px 40px" },
                overflow: "hidden",
                position: "relative",
            }}
        >
            {/* Decorative blurred circles */}
            <Box sx={{ position: "absolute", top: "10%", right: "8%", width: 340, height: 340, borderRadius: "50%", background: "rgba(74,122,242,0.09)", filter: "blur(80px)", pointerEvents: "none" }} />
            <Box sx={{ position: "absolute", bottom: "8%", left: "5%", width: 260, height: 260, borderRadius: "50%", background: "rgba(242,103,74,0.08)", filter: "blur(60px)", pointerEvents: "none" }} />

            <Box
                sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    alignItems: "center",
                    justifyContent: "center",
                    gap: { xs: 6, md: 10 },
                    maxWidth: 900,
                    width: "100%",
                    zIndex: 1,
                }}
            >
                {/* Left: Text content */}
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: { xs: "center", md: "flex-start" },
                        textAlign: { xs: "center", md: "left" },
                        animation: `${fadeUp} 0.6s ease both`,
                        flex: 1,
                    }}
                >
                    {/* Wolfpack logo + invest on your terms logo */}
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: { xs: "center", md: "flex-start" }, gap: 1.5, mb: 4 }}>
                        {/* Wolfpack logo — swap src once you have the file */}
                        <img
                            src={'wolfpackLogo'}
                            alt="Wolfpack"
                            style={{ maxWidth: 52, height: "auto" }}
                        />
                        {/* Invest on your terms tagline logo */}
                        <img
                            src={'investOnYourTerm'}
                            alt="Invest on your terms"
                            style={{ maxWidth: 190, height: "auto" }}
                        />
                    </Box>

                    {/* Headline */}
                    <Typography
                        sx={{
                            fontSize: { xs: "2rem", md: "2.6rem" },
                            fontWeight: 800,
                            color: "white",
                            lineHeight: 1.15,
                            mb: 2,
                            letterSpacing: "-0.5px",
                        }}
                    >
                        Trade Smarter,{" "}
                        <Box component="span" sx={{ color: "#F2674A" }}>
                            Anywhere
                        </Box>
                    </Typography>

                    <Typography
                        sx={{
                            fontSize: "1rem",
                            color: "rgba(255,255,255,0.55)",
                            mb: 4,
                            maxWidth: 400,
                            lineHeight: 1.7,
                        }}
                    >
                        Get the full Wolfpack experience on your phone. Real-time crypto &amp; stocks, AI picks, booster loans — all in one app.
                    </Typography>

                    {/* Store badge buttons — just images, no text needed */}
                    <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, alignItems: "center", gap: 2 }}>
                        {/* Google Play badge */}
                        <StoreButton
                            href="https://play.google.com/store/apps/details?id=inc.financial.wolfpack"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={'https://mmfiles.s3.ap-southeast-2.amazonaws.com/ProjectFiles/Group%202.png-7b4ff4d7-ae9a-4efa-b5e8-629ed9a0d4fa'}
                                alt="Get it on Google Play"
                                style={{ height: 52, width: "auto", display: "block" }}
                            />
                        </StoreButton>

                        {/* App Store badge */}
                        <StoreButton
                            href="https://apps.apple.com/in/app/wolfpack-financial/id1610870346"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={'https://mmfiles.s3.ap-southeast-2.amazonaws.com/ProjectFiles/Group%201.png-06bccd93-27dc-42e6-bcb9-71c0272641cd'}
                                alt="Download on the App Store"
                                style={{ height: 52, width: "auto", display: "block" }}
                            />
                        </StoreButton>
                    </Box>

                    <Typography sx={{ mt: 3, fontSize: "0.8rem", color: "rgba(255,255,255,0.3)" }}>
                        Free · Available on iOS &amp; Android
                    </Typography>
                </Box>

                {/* Right: Phone mockup */}
                <Box
                    sx={{
                        animation: `${fadeUp} 0.7s 0.1s ease both`,
                        display: { xs: "none", sm: "flex" },
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                        filter: "drop-shadow(0 40px 80px rgba(74,122,242,0.25))",
                    }}
                >
                    <PhoneMockup />
                </Box>
            </Box>
        </Box>
    );
};

export default DownloadApp;